<template>
  <v-container class="pa-0">
    <v-toolbar dark dense :color="appColor_Medium">
      <v-toolbar-title>
        <span><v-icon class="mr-2">person</v-icon>{{ getExpression('FormTitle', 'YourProfile', profile.languageId) }}</span>
      </v-toolbar-title>
      <!--<v-spacer />
      <v-chip small :color="functionalRoleColor" class="mr-1 elevation-1" :outlined="isAdmin">{{ functionalRoleText }}</v-chip>-->
    </v-toolbar>
    <v-card v-if="profile">
      <v-card-text class="pb-0 pt-3">
        <v-container grid-list-md class="pa-0">
          <form>
            <v-row no-gutters>
              <v-list-item class="pa-0">
                <v-list-item-avatar tile size="90" class="pa-0">
                  <v-img :src="profile.picture"></v-img>
                </v-list-item-avatar>
                <v-spacer />
                <v-list-item-icon>
                  <v-btn @click="changePicture()" dark large :color="appColor_Medium" :disabled="isSaving" class="rounded-0 mt-n2">{{ getExpression('Button', 'ChangePicture', profile.languageId) }}</v-btn>
                  <input v-show="false" type="file" accept='image/*' ref="picture" @change="uploadPicture()">
                  
                </v-list-item-icon>
              </v-list-item>
            </v-row>
            
            <v-row no-gutters>
              <v-col cols="12" xs="12">
                <v-text-field v-model="profile.email"
                  :label="getExpression('Label', 'Email', profile.languageId)"
                  disabled
                  hide-details
                  class="mb-4"
                  >
                </v-text-field>
              </v-col>
            </v-row>
           
            <v-row no-gutters>
              <v-col cols="12" xs="12">
                <v-text-field v-model="profile.name"
                  :label="getExpression('Label', 'Name', profile.languageId)"
                  v-validate="'required|alpha_spaces|max:100'"
                  :error-messages="errors.collect('name')"
                  data-vv-name="name"
                  hide-details="auto"
                  class="mb-4"
                  >
                </v-text-field>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="12" sm="7">
                <v-text-field v-model="profile.nickname"
                  :label="getExpression('Label', 'DisplayName', profile.languageId)"
                  v-validate="'max:20'"
                  :error-messages="errors.collect('nickname')"
                  data-vv-name="nickname"
                  hide-details="auto"
                  >
                </v-text-field>
              </v-col>

              <v-col cols="12" sm="5">
                <v-select
                  v-model="profile.languageId"
                  :items="languages"
                  item-value="id"
                  item-text="nativeDescription"
                  class="ml-2 mb-4"
                />
              </v-col>
            </v-row>
          </form>
        </v-container>
      </v-card-text>

      <v-card-actions>

        <v-spacer />

        <v-btn @click="cancel" :loading="isSaving" class="rounded-0" large>{{ getExpression('Button', 'Cancel', profile.languageId) }}</v-btn>
        <v-btn :color="appColor_Medium" dark @click="save" :loading="isSaving" class="rounded-0 ml-4" large :disabled="isSaving">{{ getExpression('Button', 'Save', profile.languageId) }}</v-btn>

      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import appService from '@/app.service'
import { AppColor, FunctionalUserRole, KioskTypeId, LanguageId } from '@/config.js'

export default {
  name: 'ProfileEdit',
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    return {

      // colors
      appColor_Light: AppColor.Light,
      appColor_Medium: AppColor.Medium,

      // roles
      functionalRole_Admin: FunctionalUserRole.Admin,

      // kiosk types
      kioskTypeId_Genie: KioskTypeId.Genie,

      isSaving: false,
      profileModel: {}
    }
  },
  props: {
    profile: {
      type: Object,
      default: null
    },
    profileOriginal: {
      type: Object,
      default: null
    },
    residents: {
      type: Array,
      default: null
    },
    kiosks: {
      type: Array,
      default: null
    },
    languages: {
      type: Array,
      default: null
    },
    functionalRoleText: {
      type: String,
      default: null
    },
    functionalRoleColor: {
      type: String,
      default: null
    }
  },
  computed: {
    dictionary () {
      return {
        attributes: {
          email: 'Email'
        },
        custom: {
          name: {
            required: () => this.getExpression('Validation', 'NameRequired', this.profile.languageId),
            max: this.getExpression('Validation', 'NameMaxChars', this.profile.languageId).replace('{0}', '100'),
            alpha_spaces: this.getExpression('Validation', 'NameAlphNumeric', this.profile.languageId)
          },
          nickname: {
            max: this.getExpression('Validation', 'DisplayNameMaxChars').replace('{0}', '20')
          }
        }
      }
    },
    valid () {
      return this.profile.name
    },
    hasMultipleResidents () {
      if (this.isNullOrUndefined(this.residents)) return false
      return this.residents.length > 1
    },
    dataChanged () {
      return this.profile.name !== this.profileOriginal.name ||
        this.profile.nickname !== this.profileOriginal.nickname ||
        this.profile.defaultResidentId !== this.profileOriginal.defaultResidentId ||
        this.profile.picture !== this.profileOriginal.picture ||
        this.profile.languageId !== this.profileOriginal.languageId
    }
  },
  methods: {
    save () {
      if (!this.dataChanged) {
        this.$emit('cancel')
        return
      }
    
      const self = this
      if (!self.hasMultipleResidents) {
        self.profile.defaultResidentId = null
      }

      const name = self.profile.name.trim()
      const nickname = self.profile.nickname.trim()

      self.profile.name = name
      self.profile.nickname = nickname.length === 0
        ? name.trim().split(' ')[0].substring(0, 20)
        : nickname

      // language
      var languageId = self.profile.languageId
      if (languageId === LanguageId.English) languageId = null

      const profileModel = {
        id: self.profile.id,
        email: self.profile.email,
        name: self.profile.name,
        nickname: self.profile.nickname,
        languageId: languageId,
        picture: self.profile.picture,
        defaultResidentId: self.profile.defaultResidentId
      }

      self.$validator.validateAll().then(valid => {
        if (valid) {
          self.isSaving = true
          appService.updateUserProfile(profileModel.id, profileModel).then(data => {
            if (data.errorSeverity > 0) {
              self.$emit('error', data.errorMessage)
            } else {
              self.$emit('save')
            }
            self.isSaving = false
          }).catch(e => { self.handleCriticalError(e) })
        }
      })
    },

    cancel () {
      this.$emit('cancel')
    },

    changePicture () {
      this.$refs.picture.click()
    },

    uploadPicture () {
      const self = this

      const file = self.$refs.picture.files[0]
      if (file === undefined) return

      var img = new Image();
      img.src = URL.createObjectURL(file);

      img.onload = function() {
        const imgWidth = this.width
        const imgHeight = this.height

        if (imgWidth < 400 || imgHeight < 400) {
          const text = `${self.getExpression('Alert', 'ResolutionTooLow')}` +
            `${self.getExpression('Alert', 'ImageSizeIsOnly')} ${imgWidth} x ${imgHeight} ` +
            `${self.getExpression('Alert', 'Pixels')}.`

          self.$error.show({
            title: self.getExpression('FormTitle', 'InspectionFailed'),
            text: text,
            languageId: self.profile.languageId
          })
        } else {
          let formData = new FormData()
          formData.append('file', file)
          formData.append('userId', self.profile.id)

          self.$upload.execute({
            formData: formData,
            url: 'users/picture',
            fileCount: 1,
            onComplete: (data) => {
              if (data.errorSeverity > 0) {
                self.handleError(data)
              } else {
                self.profile.picture = data.picture
              }
            }
          })
        }
      }
    },

    handleError (result) {
      this.$error.show({
        title: result.errorSeverity === 0
          ? this.getExpression('FormTitle', 'ValidationFailed', this.profile.languageId)
          : this.getExpression('FormTitle', 'InternalError', this.profile.languageId),
        text: result.errorMessage,
        severity: result.errorSeverity,
        languageId: this.profile.languageId
      })
    }
  },
  mounted() {
    this.$validator.localize('en', this.dictionary)
    this.$validator.reset()
  }
}
</script>
